import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Account, AccountStatus} from '../domain/accounts/account';
import {MediaAccess, MediaAccessStatus, MediaAccessType} from '../domain/accounts/media-access';
import {CustomerDetail} from '../domain/customer/customer-detail';
import {AccountService} from './account.service';
import {ReplaySubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerDetailService {
  customerDetail: CustomerDetail;
  private customerDetailSubject = new ReplaySubject<CustomerDetail>(1);
  customerDetail$ = this.customerDetailSubject.asObservable();
  constructor(
    private http: HttpClient,
    private accountService: AccountService
  ) {
  }

  clearCustomerDetal() {
    this.customerDetail = null;
    this.customerDetailSubject = new ReplaySubject<CustomerDetail>(1);
    this.customerDetail$ = this.customerDetailSubject.asObservable();
  }

  getInstance(refresh = false) {
    if (this.customerDetail && refresh){
      return;
    }
    this.accountService.getDetail().pipe(
      map(
        (response: any) => {
          this.customerDetail = response;
          this.customerDetail.account = this.getActiveAccount();
          this.customerDetail.mediaAccess = this.getMediaAccessBy(null, MediaAccessType.CARD);
          return this.customerDetail;
        }
      )
    ).subscribe(customerDetail => this.customerDetailSubject.next(customerDetail),
      error => this.customerDetailSubject.next(error));
  }

  getActiveAccount() {
    const account: Account = this.customerDetail?.accounts?.find((item) => item.status === AccountStatus.ACTIVE);
    return account || null;
  }

  logOut() {
    if (this.customerDetail) {
      this.customerDetail = null;
    }
    this.customerDetailSubject = new ReplaySubject<CustomerDetail>(1);
    this.customerDetail$ = this.customerDetailSubject.asObservable();
  }

  getMediaAccessBy(status: MediaAccessStatus, type: MediaAccessType) {
    let mediaAccess: MediaAccess;
    if (this.customerDetail?.account?.mediaAccess.length > 0) {
      const now: Date = new Date();
      mediaAccess = this.customerDetail.account.mediaAccess.reduce((a, b) => {
          if (a.activationDate != null && b.activationDate != null) {
            // @ts-ignore
            return Math.abs(a.activationDate - now) < Math.abs(b.activationDate - now) ? a : b;
          }

          if (a.activationDate == null && b.activationDate != null) {
            return b;
          }

          if (a.activationDate != null && b.activationDate == null) {
            return a;
          }

          return new MediaAccess();
        }
      );
      if (mediaAccess != null) {
        let res = true;
        if (status != null) {
          res = res && mediaAccess.status === status;
        }
        if (type != null) {
          res = res && mediaAccess.type === type;
        }
        if (!res) {
          mediaAccess = null;
        } else {
          mediaAccess.maskedValue = `●●●● ●●●● ●●●● ${mediaAccess.maskedValue.substring(mediaAccess.maskedValue.length - 4)}`;
        }
      }
    }
    return mediaAccess;
  }

}
